module.exports = __webpack_public_path__ + "static/media/KaenguruMockUp_Preview.3152de24.png";